"use strict";

/**
* Объект панели "Создать".
*
* @class WebAccess.components.CreatePanel
* @extends BaseObject
* @property {object} _model Модель панели "Создать"
* @property {object} buttons Коллекция объектов кнопок панели "Создать"
*/

(function (global) {
  var CreatePanel = BaseObject.extend({

    _model: {},
    buttons: {},
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Конструктор
     * @param {object} model Модель панели "Создать"
     * @method WebAccess.components.CreatePanel#init
     */
    init: function (model) {
      var me = this;
      me._model = model;
      model.forEach(function(button_model) {
        me._initButton(button_model);
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Проинициализировать в клиентском API кнопку панели "Создать".
     *
     * @param {string} button_model Модель кнопки панели "Создать"
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     */
    _initButton: function (button_model) {
      var me = this;
      var button = new global.ActionButton(button_model);
      me.buttons[button_model.id] = button;
      button.bind(button['class'].EVENT.CHANGE_STATE, function () {
        me.fire(me['class'].EVENT.CHANGE_STATE);
      });
      return button;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Создает кнопку на панели "Создать".
     *
     * @method WebAccess.components.CreatePanel#createButton
     * @param {string} button_name Имя создаваемой кнопки
     * @param {object} params Параметры кнопки
     * @throws ERR_BUTTON_NAME_IS_NOT_SPECIFIED_PROPERLY – некорректно указано имя кнопки;
     * @throws ERR_BUTTON_WITH_THE_SAME_NAME_ALREADY_EXIST – кнопка с указанным именем уже существует.
     * @return {WebAccess.components.ActionButton} Объект типа ActionButton.
     *
     * @example
     * WebAccess.current.createPanel.createButton('newButton', {disabled: fasle, text: L('CREATE_DOCUMENT'), icon: 'task-32'})
     * или
     * WebAccess.current.createPanel.createButton('newButton')
     *          .enable()
     *          .setLabel(L('CREATE_DOCUMENT'))
     *          .setIcon('SidebarAndExtensions/EDocumentSearch_24.png') 
     */
    createButton: function (button_name, params) {
      var me = this;
      if (!button_name || typeof button_name !== 'string') WebAccess.raise('ERR_BUTTON_NAME_IS_NOT_SPECIFIED_PROPERLY');
      // Проверяем, существует ли такая кнопка.
      for (var i = 0, len = me._model.length; i < len; i++) {
        if (me._model[i].id == button_name) WebAccess.raise('ERR_BUTTON_WITH_THE_SAME_NAME_ALREADY_EXIST', button_name);
      };
      if (typeof params !== 'object') params = {};
      // id модели кнопки должен быть в любом случае равен button_name
      params.id = button_name;
      me._model.push(params);
      me.fire(me['class'].EVENT.CHANGE_STATE);
      return me._initButton(params);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Удаляет кнопку с панели "Создать".
     *
     * @method WebAccess.components.CreatePanel#removeButton
     * @param {string} button_name Имя удаляемой кнопки
     * @return {WebAccess.components.CreatePanel} Объект типа CreatePanel.
     */
    removeButton: function (button_name) {
      var me = this;
      for (var i = 0, len = me._model.length; i < len; i++) {
        if (me._model[i].id == button_name) {
          delete me.buttons[me._model[i].id];
          me._model.splice(i, 1);
          me.fire(me['class'].EVENT.CHANGE_STATE);
          break;
        }
      };
      return me;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  }, {
    /**
     * События.
     */
    EVENT: {
      /**
       * Срабатывает при изменении количества или свойств кнопок панели "Создать".
	   * В последнем случае событие прокидывается из дочерних объектов.
       */
      CHANGE_STATE: 'changeState'
    }
  });

  global.CreatePanel = CreatePanel;

})(window.WebAccess.components);
